import { Icon, IconProps } from "@chakra-ui/react";

export const TelegramIcon = ({ ...rest }: IconProps) => (
  <Icon width={6} height={6} viewBox="0 0 24 24" {...rest}>
    <path
      d="M2.75953 11.162C8.53196 8.56082 12.3812 6.84597 14.3071 6.01744C19.8061 3.65183 20.9487 3.24089 21.6935 3.22718C21.8573 3.22434 22.2235 3.26632 22.4608 3.46543C22.6611 3.63355 22.7162 3.86065 22.7426 4.02005C22.769 4.17944 22.8018 4.54255 22.7757 4.82627C22.4777 8.06462 21.1883 15.9232 20.5324 19.5503C20.2547 21.0849 19.7082 21.5996 19.179 21.6499C18.0293 21.7593 17.156 20.864 16.0423 20.1088C14.2996 18.9273 13.315 18.1918 11.6234 17.0388C9.66842 15.7063 10.9357 14.974 12.0499 13.7771C12.3414 13.4639 17.4078 8.69761 17.506 8.26523C17.5182 8.21116 17.5296 8.0096 17.4138 7.90316C17.298 7.79672 17.1271 7.83312 17.0038 7.86206C16.8291 7.90309 14.045 9.80638 8.6516 13.5718C7.86135 14.1331 7.14556 14.4065 6.50424 14.3922C5.79724 14.3764 4.43726 13.9787 3.42624 13.6388C2.1862 13.222 1.20064 13.0015 1.28646 12.2935C1.33116 11.9247 1.82219 11.5475 2.75953 11.162Z"
      fill="currentColor"
    />
  </Icon>
);

export const TwitterIcon = ({ ...rest }: IconProps) => (
  <Icon width={6} height={6} viewBox="0 0 24 24" {...rest}>
    <path
      d="M17.8341 3.84009H20.7655L14.3612 11.1597L21.8953 21.1201H15.9962L11.3758 15.0792L6.08899 21.1201H3.15582L10.0058 13.2909L2.77832 3.84009H8.82721L13.0037 9.36171L17.8341 3.84009ZM16.8053 19.3655H18.4296L7.9446 5.50251H6.20153L16.8053 19.3655Z"
      fill="currentColor"
    />
  </Icon>
);
